import { render } from "./LimitsDetail.vue?vue&type=template&id=937ee0f0&scoped=true"
import script from "./LimitsDetail.vue?vue&type=script&lang=js"
export * from "./LimitsDetail.vue?vue&type=script&lang=js"

import "./LimitsDetail.vue?vue&type=style&index=0&id=937ee0f0&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-937ee0f0"]])

export default __exports__